// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    User,
    UserFromJSON,
    UserToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectActivity
 */
export interface ProjectActivity {
    /**
     * Type of entity
     * @type {string}
     * @memberof ProjectActivity
     */
    entity: string;
    /**
     * Activity Type
     * @type {string}
     * @memberof ProjectActivity
     */
    activityType?: ProjectActivityActivityTypeEnum;
    /**
     * 
     * @type {User}
     * @memberof ProjectActivity
     */
    user?: User;
    /**
     * Time when the activity was performed
     * @type {string}
     * @memberof ProjectActivity
     */
    time: string;
    /**
     * A hyperlinked title
     * @type {string}
     * @memberof ProjectActivity
     */
    title: string;
}

export function ProjectActivityFromJSON(json: any): ProjectActivity {
    return {
        'entity': json['entity'],
        'activityType': !exists(json, 'activity_type') ? undefined : json['activity_type'],
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'time': json['time'],
        'title': json['title'],
    };
}

export function ProjectActivityToJSON(value?: ProjectActivity): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'entity': value.entity,
        'activity_type': value.activityType,
        'user': UserToJSON(value.user),
        'time': value.time,
        'title': value.title,
    };
}

/**
* @export
* @enum {string}
*/
export enum ProjectActivityActivityTypeEnum {
    Add = 'add',
    Edit = 'edit',
    Delete = 'delete',
    Run = 'run',
    FinishedRun = 'finished_run',
    Comment = 'comment'
}


